import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in (from localStorage)
    const savedUser = localStorage.getItem('facit_user');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (error) {
        console.error('Error parsing saved user:', error);
        localStorage.removeItem('facit_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (userData) => {
    try {
      // If no userData provided, create a default user (for simple authentication)
      const userToLogin = userData || {
        id: '1',
        name: 'Utilisateur',
        email: 'admin@facit.local',
        role: 'admin'
      };
      
      setUser(userToLogin);
      localStorage.setItem('facit_user', JSON.stringify(userToLogin));
      
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Erreur de connexion' };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('facit_user');
  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 